import { Box, SimpleGrid, Stat, StatLabel, StatNumber, useColorModeValue } from '@elkaso-app/web-design';
interface DemandMetricsSectionProps {
  metrics: {
    restaurantsOrdering: number;
    totalOrders: number;
    avgMonthlyOrders: number | null;
    avgOrderQuantity: number;
  };
}

export const DemandMetricsSection = ({ metrics }: DemandMetricsSectionProps) => {
  const bgColor = useColorModeValue('gray.50', 'gray.700');

  const cards = [
    { label: 'Restaurants Ordering', value: metrics.restaurantsOrdering ?? 0 },
    { label: 'Total Orders', value: (metrics.totalOrders ?? 0).toLocaleString() },
    { label: 'Avg Monthly Orders', value: metrics.avgMonthlyOrders ?? 0 },
    { label: 'Avg Order Quantity', value: metrics.avgOrderQuantity ?? 0 },
  ];

  return (
    <SimpleGrid columns={{ base: 2, md: 4 }} spacing={4}>
      {cards.map((card) => (
        <Box key={card.label} p={4} bg={bgColor} borderRadius='md'>
          <Stat>
            <StatLabel fontSize='xs' color='gray.500'>
              {card.label}
            </StatLabel>
            <StatNumber fontSize='xl'>{card.value}</StatNumber>
          </Stat>
        </Box>
      ))}
    </SimpleGrid>
  );
};
